import React, { useState } from 'react';
import {
  Box, Button, Container, Grid, Paper, Typography, Card, CardContent,
  Avatar, Divider, CardActions, Tab
} from "@mui/material";
import { StudentLayout } from "../../layouts";
import Tabs from '@mui/material/Tabs';
import { ProfileDataView } from './views/ProfileDataView';
import { MyTicketsView } from './views/MyTicketsView';


export const ProfilePage = () => {

  const defaultProfilePic = 'https://source.unsplash.com/random';



  // Ejemplo de datos por defecto, reemplazar con los datos de tu base de datos
  const userData = {
    fullName: 'Juan Ramirez',
    email: 'juan.ramirez@example.com',
    phone: '123-456-7890',
    birthDate: '1980-01-01', // formato YYYY-MM-DD
  };



  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: any, newValue: any) => {
    setTabValue(newValue);
  };

  interface TabPanelProps {
    children?: React.ReactNode;
    index: any;
    value: any;
  }

  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  function a11yProps(index: any) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  return (
    <StudentLayout>
      <Container sx={{ mt: 5 }}>

        <Grid container spacing={5}>

          <Grid item xs={12}>
            <Typography variant='h4' sx={{ fontWeight: 700 }} color={'primary'}>Mi cuenta</Typography>
          </Grid>

          <Grid item xs={12} md={3}>
            <Card variant='outlined' sx={{ textAlign: 'center' }}>
              <CardContent>

                <Avatar
                  sx={{ width: 100, height: 100, margin: 'auto', my: 2 }}
                  src={defaultProfilePic} // Reemplazar con la imagen del perfil del usuario
                />



                <Typography variant='h5' sx={{ fontWeight: 700 }} color={'primary'}>Juan Ramirez</Typography>
                <Typography variant='subtitle1' color="text.secondary">Desde 11 nov 2023</Typography>


                <Divider sx={{ my: 2 }} />
                <Box display="flex" justifyContent="space-around" alignItems="center">
                  <Box>
                    <Typography variant="body1" >Eventos Asistidos</Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 700 }}>15</Typography>
                  </Box>
                  <Box>
                    <Typography variant="body1" >Entradas Compradas</Typography>
                    <Typography variant="h6" color="text.secondary" sx={{ fontWeight: 700 }}>200</Typography>
                  </Box>
                </Box>
              </CardContent>
              <CardActions sx={{ flexDirection: 'column', mb: 2, mx: "auto" }}>
                <Typography variant='body1' color="text.secondary">
                  ¿Te gustaría ser organizador?
                </Typography>
                <Button variant="contained" color='secondary' sx={{ mt: 1, }}>Descubre como</Button>
              </CardActions>
            </Card >
          </Grid>

          <Grid item xs={12} md={8}>

            <Paper elevation={1} variant='outlined' sx={{ borderRadius: 2 }}>

              {/*   // Aquí puedes poner el contenido de los tabs */}
              <Box sx={{ borderBottom: 1, borderColor: 'divider', }}>
                <Tabs
                  value={tabValue}
                  onChange={handleTabChange}
                  aria-label="profile tabs"
                  variant="fullWidth"
                  sx={{ borderBottom: 1, borderColor: 'divider', '.MuiTabs-indicator': { backgroundColor: 'secondary.main' } }}
                >
                  <Tab label="Mi Perfil" {...a11yProps(0)} />
                  <Tab label="Mis eventos" {...a11yProps(1)} />
                  {/*  <Tab label="Calendario" {...a11yProps(3)} /> */}

                </Tabs>
              </Box>
              <TabPanel value={tabValue} index={0}>

                < ProfileDataView userData={userData} />
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                {/* Contenido para el segundo tab */}
                <MyTicketsView />
              </TabPanel>
            </Paper>



          </Grid>

        </Grid>

      </Container>
    </StudentLayout >
  )
}
